import * as React from 'react';
import * as styles from './ProjectsList.css';

interface IProjectsListProps {
  list: React.ReactNode;
  showMoreButton: React.ReactNode;
}

export function ProjectsList({ list, showMoreButton }: IProjectsListProps) {
  return (
    <div className={styles['list']}>
      <div className={styles['list__cards']}>{list}</div>

      <div className={styles['list__show-wrapper']}>{showMoreButton}</div>
    </div>
  );
}
